import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { axiosInstance } from "../../network/apis";
import {
  GET_AGREEMENT_LATEST_DATA_URL,
  GET_CHECKLIST_STORE_URL,
  GET_CHECKLIST_URL,
  GET_RESCHEDULE_DATA_URL,
  GET_SCHEDULE_DATA_URL,
  POST_ADD_BULK_SCHEDULE_URL,
  POST_UPDATE_SCHEDULE_URL,
} from "../../network/apis/apiPath";
import { CHECKLIST_PLANNER_PATH } from "../../utils/Constants";
import { getLocalStoreString } from "../../utils/Helper";
import {
  GET_CHECKLIST_DATA,
  GET_CHECKLIST_STORE_DATA,
  GET_RESCHEDULE_HISTORY,
  GET_SCHEDULE_DATA,
  IS_CHECKED_DATA,
  POST_ADD_BULK_SCHEDULE,
  POST_UPDATE_SCHEDULE,
  SAVE_CHECKLIST_DATE,
} from "../type";
import {
  saveChecklistDatePreserve,
  saveGetChecklist,
  saveGetChecklistStore,
  saveGetScheduleData,
  saveIsChecked,
  saveReScheduleHistory,
} from "./checklistConfigSlice";

function* getStore(action) {
  const { setLoader } = action;
  const empCode = getLocalStoreString("EmployeeCode");
  console.log("************");
  console.log(GET_CHECKLIST_STORE_URL);
  console.log("************");
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_CHECKLIST_STORE_URL}?employeeCode=${empCode}`
    );
    if (response) {
      yield put(saveGetChecklistStore(response?.data?.visitingStores));
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
}

function* getCheckList(action) {
  const { setLoader } = action;
  const empCode = getLocalStoreString("EmployeeCode");
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_CHECKLIST_URL}?employeeCode=${empCode}`
    );
    if (response) {
      yield put(saveGetChecklist(response?.data));
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
}

function* isCheckedData(action) {
  yield put(saveIsChecked(action?.payload));
}

const MAX_RETRIES = 3; // Maximum number of retries
const RETRY_DELAY = 1000;

function* getScheduleData(action) {
  console.log("--- Planner schedule ---");
  console.log(action);
  console.log("--- Planner schedule ---");
  const empCode = getLocalStoreString("EmployeeCode");
  const { setScheduleData, payload, setLoader } = action;
  const { startDate, endDate, statusData, selectedStores } = payload;

  let retries = 0;

  while (retries < MAX_RETRIES) {
    try {
      const response = yield call(
        axiosInstance.get,
        `${GET_SCHEDULE_DATA_URL}?startDate=${startDate}&endDate=${endDate}&pageNumber=0&pageSize=1000&employeeCode=${empCode}&status=${statusData}`
      );

      if (response) {
        yield put(saveGetScheduleData(response?.data?.entities));
        let filteredScheduleData;
        if (selectedStores.length === 0) {
          filteredScheduleData = response?.data?.entities;
        } else {
          filteredScheduleData = response?.data?.entities.filter((item) =>
            selectedStores?.includes(item.storeName)
          );
        }
        setScheduleData(filteredScheduleData);
        setLoader(false);
        return; // Exit the function if successful
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        retries++;
        console.log(`Retry ${retries}/${MAX_RETRIES}`);
        if (retries >= MAX_RETRIES) {
          console.log("Max retries reached. Failing.");
          setLoader(false);
          return; // Exit the function after maximum retries
        }
        // Delay before retrying
        yield new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
      } else {
        console.log("error", error);
        setLoader(false);
        return; // Exit the function if an error other than 400 occurs
      }
    }
  }
}

function* postAddScheduleData(action) {
  const { payload, navigate, enqueueSnackbar } = action;
  try {
    const response = yield call(
      axiosInstance.post,
      POST_ADD_BULK_SCHEDULE_URL,
      payload
    );
    if (response?.status == 200) {
      navigate(CHECKLIST_PLANNER_PATH);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* postUpdateScheduleData(action) {
  const { payload, navigate, enqueueSnackbar } = action;
  const { scheduleId, payloadData } = payload;
  try {
    const response = yield call(
      axiosInstance.post,
      `${POST_UPDATE_SCHEDULE_URL}${scheduleId}`,
      payloadData
    );
    if (response?.status == 200) {
      navigate(CHECKLIST_PLANNER_PATH);
    }
  } catch (error) {
    console.log("error", error);
    const errorContent = error?.response?.data?.message;
    CustomMessage(errorContent, "error", enqueueSnackbar);
  }
}

function* getReScheduleHistoryData(action) {
  const { scheduleId } = action?.payload;
  try {
    const response = yield call(
      axiosInstance.get,
      `${GET_RESCHEDULE_DATA_URL}${scheduleId}`
    );
    if (response) {
      yield put(saveReScheduleHistory(response?.data));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* checklistDatePreserve(action) {
  yield put(saveChecklistDatePreserve(action?.payload));
}

export function* checklistConfigWatcher() {
  yield takeLatest(GET_CHECKLIST_STORE_DATA, getStore);
  yield takeLatest(GET_CHECKLIST_DATA, getCheckList);
  yield takeLatest(IS_CHECKED_DATA, isCheckedData);
  yield takeLatest(GET_SCHEDULE_DATA, getScheduleData);
  yield takeLatest(POST_ADD_BULK_SCHEDULE, postAddScheduleData);
  yield takeLatest(POST_UPDATE_SCHEDULE, postUpdateScheduleData);
  yield takeLatest(GET_RESCHEDULE_HISTORY, getReScheduleHistoryData);
  yield takeLatest(SAVE_CHECKLIST_DATE, checklistDatePreserve);
}
